import React from "react";
import classNames from "classnames/bind";
import styles from "../../AddJobModal.module.scss";
import { ArrowRightIcon } from "~/assets/icons";
import { ICustomer } from "~/apis/crm";

const cx = classNames.bind(styles);

interface ContactListProps {
  customers: ICustomer[];
  selectedContacts: ICustomer[];
  onSelectContact: (contact: ICustomer) => void;
}

const ContactList: React.FC<ContactListProps> = ({
  customers,
  selectedContacts,
  onSelectContact,
}) => {
  if (customers.length === 0) {
    return (
      <div className={cx("no-contacts")}>
        <p>No contacts found</p>
      </div>
    );
  }

  return (
    <div className={cx("available-contacts")}>
      {customers.map((contact) => {
        const isSelected = selectedContacts.some((c) => c.id === contact.id);
        return (
          <div
            key={contact.id}
            className={cx("contact-item", { selected: isSelected })}
            onClick={() => onSelectContact(contact)}
          >
            <div className={cx("contact-info")}>
              <p className={cx("contact-title")}>{contact.name}</p>
              {contact.email && (
                <p className={cx("contact-content")}>{contact.email}</p>
              )}
              {contact.phoneNumber && (
                <p className={cx("contact-content")}>{contact.phoneNumber}</p>
              )}
              {!contact.email && !contact.phoneNumber && (
                <p className={cx("contact-content")}>
                  {contact.address || "No contact info"}
                </p>
              )}
            </div>
            <ArrowRightIcon className={cx("arrow-icon")} />
          </div>
        );
      })}
    </div>
  );
};

export default ContactList;
